module.exports = __webpack_public_path__ + "img/p6.997dc287.png";